import { Span } from "@virtual-brain-lib/frontend-design-system/ui";

interface DocumentSectionHeaderProps {
	readonly label: string;
}

export function DocumentSectionHeader({ label }: DocumentSectionHeaderProps) {
	return (
		<Span
			isBlock
			className="mt-1 tracking-wide uppercase"
			color="defaultLight"
			variant="tag-sm"
		>
			{label}
		</Span>
	);
}
